import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataCafService {
  private codigo_dte_seleccionada = new BehaviorSubject<number>(0);
  public codigo_dte_seleccionada$ = this.codigo_dte_seleccionada.asObservable();

  

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  getDataCaf(inputParams: any, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: data_cafInputType) {
          data_caf {
            getDataCAF(entidad: $entidad) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                codigo_dte
                nombre_dte
                fecha_emision
                fecha_vencimiento
                folios_disponibles
                ultimo_folio
                folios_inicial
                folios_final
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.data_caf.getDataCAF
        callback({ mensajes, respuesta })
      }
    );
  }
  getAllDataCaf(inputParams: any, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: data_cafInputType) {
            data_caf {
              getAllDataCAF(entidad: $entidad) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  codigo_dte
                  nombre_dte
                  fecha_emision
                  fecha_vencimiento
                  folios_disponibles
                  ultimo_folio
                  folios_inicial
                  folios_final
                }
              }
            }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.data_caf.getAllDataCAF
        callback({ mensajes, respuesta })
      }
    )
  }
  setDataCodigoDTE(codigo: number) {
    this.codigo_dte_seleccionada.next(codigo);
  }
}